export class supportedFileTypes {
  public static readonly supportedVideos = ['avi', 'mov', 'mp4', 'wmv', 'm3u8', 'MOV', '3gp', 'mebm'];
  public static readonly supportedImages = ['png', 'jpg', 'jpeg'];
  public static readonly supportedText = ['txt', 'csv'];
}
